module.exports = __webpack_public_path__ + "media/images/white_logo-2492e442510e941d767449d8293f2ee85d9b8db36db7c4bd2c235578a668ac6b.png";